import Route from '@ember/routing/route';
import { get, set } from '@ember/object';
import { service } from '@ember/service';
import logger from 'donor-elf-web/lib/logger';

export default Route.extend({
  navbarSettings: service(),
  router: service(),

  beforeModel(transition) {
    set(this, 'navbarSettings.title', 'Not Found');
    logger.error(
      `invalid fund token while going to url: ${transition.intent.url}. From route: ${get(this, 'router.currentRouteName')}`,
    );
  },
});
